<div class="oc-legend">
  <span class="oc-legend__item">
    <span class="oc-swatch oc-swatch--regular"></span>
    {{ 'portOvertimeRules.levels.regular' | translate }}
  </span>
  <span class="oc-legend__item">
    <span class="oc-swatch oc-swatch--ot1"></span>
    {{ 'portOvertimeRules.levels.ot1' | translate }}
  </span>
  <span class="oc-legend__item">
    <span class="oc-swatch oc-swatch--ot2"></span>
    {{ 'portOvertimeRules.levels.ot2' | translate }}
  </span>
</div>

<div class="oc-timeline u-card">
  <div class="oc-grid">
    <!-- Empty spacer column, lined up with the hour ticks instead of a day bar. -->
    <div class="oc-hours-col">
      <span class="oc-day-label"></span>
      <div class="oc-hours-col__track">
        @for (hour of hourMarks; track hour) {
          <span class="oc-hours-col__tick" [style.top.%]="(hour / 24) * 100">{{ hour }}h</span>
        }
      </div>
    </div>

    <!-- One column per weekday, each a 24h bar with its rules painted on top. -->
    @for (day of weekdays; track day) {
      <div class="oc-day-col">
        <span class="oc-day-label">{{ dayLabel(day) }}</span>

        <div class="oc-bar">
          <!-- Drawn first so the segments below paint on top of them, covering the lines
               where a segment sits — an overtime block reads as one solid section, only
               the plain Regular (green) background keeps the hourly gridlines visible. -->
          @for (hour of hourGridlines; track hour) {
            <span class="oc-bar__hour-line" [style.top.%]="(hour / 24) * 100"></span>
          }

          @for (segment of segmentsForDay(day); track segment.ruleId + '-' + segment.startMinute) {
            <button
              type="button"
              class="oc-segment"
              [class.oc-segment--ot1]="segment.level === Level.OT1"
              [class.oc-segment--ot2]="segment.level === Level.OT2"
              [class.oc-segment--crosses]="segment.crossesMidnight"
              [style]="segmentStyle(segment)"
              [title]="segment.crossesMidnight ? ('portOvertimeRules.crossesMidnight' | translate) : ''"
              (click)="onSegmentClick(segment.ruleId)">
              @if (segment.crossesMidnight) {
                <span class="oc-segment__wrap-icon">⟳</span>
              }
              <span class="oc-segment__time">{{ segmentLabel(segment) }}</span>
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
